<div class="rules accordion" [class.main-accordian]="depth === 0" id="rules?.id">
    <div class="accordion-item" *ngFor="let rule of rules">
        <h3 class="accordion-header d-flex">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#'+rule.id" >
                {{ rule.title }}
                <span class='badge text-bg-secondary position-absolute' style="right: 30px;" data-toggle="tooltip" data-title="version 1.0">v{{rule.version}}</span>
                <!-- <b>&nbsp;<sup>&nbsp;V<sub>{{rule.version}}</sub></sup></b> -->
            </button>
        </h3>
        <div [id]="rule.id" class="accordion-collapse collapse" #divId [attr.data-bs-parent]="rule.id">
            <div class="accordion-body">
                <p>{{ rule.content }}</p>
                <!-- <p class="rule-para">{{rule.paragraph}}</p> -->
                <app-rules id="rules.id" [rules]="rule?.subContents" [depth]="depth + 1"></app-rules>
            </div>
        </div>
    </div>  
</div>